import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FITHGameConfig} from "../FITHGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {FITHParsedGameData} from "../server/data/FITHParsedGameData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {FITHGameMode} from "../gameMode/FITHGameMode";

export class FITHWinWaysBoardView extends BaseView {
    private _item: PIXI.BitmapText;
    private _winWays: string = "";
    private _mode: string = "";

    /**
     * @description Entering FS.
     */
    public enterFS(): void {
        this.toggleWinWaysItemVisibility(false);
    }

    /**
     * @description Exiting FS.
     */
    public exitFS(): void {
        this.toggleWinWaysItemVisibility(true);
    }

    public onBeforeSpinStart(): void {
        this.updateWinWaysItem("");
    }

    protected addEventListeners() {
        super.addEventListeners && super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.STOPPED, () => this.updateWinWaysItem(this._winWays));
    }

    protected initAnimations() {
        super.initAnimations && super.initAnimations();

        StageManager.getLayer(FITHGameConfig.instance.LAYERS.WIN_WAYS_BOARD.name).addChild(this);

        this.createItem();
    }

    private updateWinWaysItem(val: string): void {
        const xOffset: number = 230;

        this._item.text = val;
        this._item.x = ((FITHGameConfig.instance.REEL_AREA_POS_X + FITHGameConfig.instance.REEL_AREA_WIDTH) - xOffset - this._item.width / 2);

        this.visible = (val !== "" && this._mode !== FITHGameMode.BONUS);
    }

    private onGameDataParsed(data: FITHParsedGameData): void {
        this._winWays = data.totalNumberOfWays;
        this._mode = data.mode;
    }

    private createItem(): void {
        const item: PIXI.BitmapText = new PIXI.BitmapText("", {
                fontName: "NumbersWays",
                fontSize: 26
            }),
            yPos: number = 82,
            xOffset: number = 230,
            waysImage: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("ways")[0]);

        item.position.set((FITHGameConfig.instance.REEL_AREA_POS_X + FITHGameConfig.instance.REEL_AREA_WIDTH) - xOffset - item.width / 2, yPos);

        waysImage.anchor.set(0.5);
        waysImage.position.set(item.x, (yPos + 48));

        this.addChild(waysImage, item);

        this._item = item;

        this.visible = false;
    }

    /**
     * @description Toggle win ways item's visibility.
     * @param visible
     */
    private toggleWinWaysItemVisibility(visible: boolean): void {
        this.visible = visible;
    }
}